import React, { useState } from "react";
import {
  makeStyles,
  Box,
  Button, 
} from "@material-ui/core";
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';

//ANCHOR 上捲
export default function ScrollTo(){
  const useStyles = makeStyles((theme) => ({
    button: {
      backgroundColor: 'white',
      minWidth: "50px",
      minHeight: "50px",
      color: "black",
      borderRadius: "25px",
      boxShadow:'0px 6px 4px 0px #cccccc',
      "&:hover": {
        backgroundColor: 'white',
        boxShadow:'0px 6px 6px 0px #cccccc',
      },
    },
  }));
  const classes = useStyles();
  const [ show, setShow]=useState();

  window.addEventListener("scroll", function () {
    if (window.pageYOffset > 400) {
      setShow(true);
    } else {
      setShow(false);
    }
  });
  
  function goTop(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  return (
    <Box
      style={{
        display: show ? "flex" : "none",
        position: "fixed",
        top: "90vh",
        right: "30px",
        zIndex: 2,
      }}
    >
      <Button className={classes.button} onClick={() => goTop()}>
        <VerticalAlignTopIcon />
      </Button>
    </Box>
  );
}